/**
 * Created by piotr.pozniak@thebeaverhead.com on 12/06/2021.
 */

import { CT, IT } from "../../../consts";

const eventDetailsShowAddToCalendar = [
  {
    field: "eventDetailsShowAddToCalendar",
    value: 1,
    defaultValue: 1,
  },
];

export const definitions = {
  title: "Events listing/Details colors",
  icon: "brush",
  groups: [
    {
      label: "Listing",
      options: [
        {
          title: "Left border",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.detailedList,
            CT.bubble,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          applicable: "design",
          integrations: [IT.google],
          name: "accentColor",
          defaultValue: "#b476c9",
          style: {
            selector: [".events-list--row-wrapper"],
            property: "background-color",
          },
          dependency: [
            {
              field: "generalUseEventAccent",
              value: 0,
              defaultValue: 1,
              message:
                'This option is overwritten by "Use calendar color as accent color" option',
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },

        {
          title: "All other borders",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "borderColor",
          defaultValue: "#e5e5e5",
          style: [
            {
              selector: ".events-list--row-separator",
              property: "background-color",
            },
            {
              selector: [".events-list--row::after"],
              property: "background-color",
            },
            {
              selector: [".events-list-container"],
              property: [
                "border-right-color",
                "border-top-color",
                "border-bottom-color",
              ],
            },
            {
              selector: [".event-row--details .row"],
              property: ["border-bottom-color"],
            },
            {
              selector: [
                ".event-row--details .row-doubled .col-content.col-content--right",
              ],
              property: ["border-bottom-color"],
            },
            {
              selector: [
                ".event-row--details .row-doubled .col-content.col-content--right",
              ],
              property: ["border-right-color"],
            },
            {
              selector: [".event-row--details .row-doubled"],
              property: ["border-bottom-color"],
            },
            {
              selector: [".event-details--wrapper"],
              property: ["border-left-color"],
            },
          ],

          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Background",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventBackgroundColor",
          defaultValue: "#fff",
          style: [
            { selector: ".events-list--row", property: "background-color" },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Background hover",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventBackgroundHoverColor",
          defaultValue: "#fbfbfb",
          style: [
            {
              selector: ".events-list--row:hover",
              property: "background-color",
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },

        {
          title: "Main date",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "mainDateTypography",
          defaultValue: {
            fontSize: "1.9em",
            fontWeight: "700",
            letterSpacing: "0px",
            lineHeight: "1.1em",
            textTransform: "uppercase",
            color: "#ababab",
            colorHover: "#ababab",
          },
          style: {
            selector: [".events-list--date-container"],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },

        {
          title: "Event title",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventTitleTypography",
          defaultValue: {
            fontSize: "22px",
            fontWeight: "700",
            letterSpacing: "0px",
            lineHeight: "1.2em",
            textTransform: "none",
            color: "#6B6B6B",
            colorHover: "#6B6B6B",
          },
          style: {
            selector: [".events-list--event-description h2"],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
        {
          title: "Event heading summary",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventHeadingSummaryTypography",
          defaultValue: {
            fontSize: "0.7em",
            fontWeight: "400",
            letterSpacing: "0px",
            lineHeight: "1.2em",
            textTransform: "none",
            color: "#6B6B6B",
            colorHover: "#6B6B6B",
          },
          style: {
            selector: [".events-list--event-description p"],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
        {
          title: "Labels",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsLabelsTypography",
          defaultValue: {
            fontSize: "1em",
            fontWeight: "700",
            letterSpacing: "0px",
            lineHeight: "1em",
            textTransform: "uppercase",
            color: "#ababab",
            colorHover: "#ababab",
          },
          style: {
            selector: [
              ".event-row--details h3",
              ".event-row--details .col-icon .material-icons",
            ],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },

        {
          title: "Event details",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventSummaryTypography",
          defaultValue: {
            fontSize: "16px",
            fontWeight: "400",
            letterSpacing: "0px",
            lineHeight: "24px",
            textTransform: "none",
            color: "#6B6B6B",
            colorHover: "#6B6B6B",
          },
          style: {
            selector: [
              ".event-row--details-row .event-row--details__pre",
              ".event-row--details-row .event-row--details__pre p",
              ".event-row--details-row .event-row--details__pre li",
              ".event-row--details p",
            ],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
        {
          title: "Show on map button box",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsMapBtn",
          defaultValue: {
            bg: "#fff",
            bgHover: "#aaaaaa",
            borderRadius: "6px",
            padding: "4px 8px 4px 8px",
            borderWidth: "1px",
            borderColor: "#cdcdcd",
          },
          style: {
            selector: [".dc-address-link--link"],
          },
          show: [
            {
              field: "eventDetailsLinkLocation",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderColorHover: true,
              showBorderRadius: true,
            },
          },
        },
        {
          title: "Show on map button label",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "eventDetailsMapBtnTypography",
          defaultValue: {
            fontSize: "1em",
            lineHeight: "1.5em",
            fontWeight: "400",
            color: "#cdcdcd",
            colorHover: "#aaaaaa",
          },
          style: {
            selector: [".dc-address-link--link"],
          },
          show: [
            {
              field: "eventDetailsLinkLocation",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
      ],
    },
    {
      label: "Details",
      options: [
        {
          title: "Popup background",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "popupBackgroundColor",
          defaultValue: "#d2d2d2",
          style: [
            {
              selector: [
                (uuid) => `.event-modal--wrapper.dce_calendar__${uuid}`,
                (uuid) => `.events-list-modal--wrapper.dce_calendar__${uuid}`,
              ],
              property: "background-color",
            },
          ],
          show: [
            {
              field: "generalOpenDetailsModal",
              value: 1,
              defaultValue: 1,
            },
          ],
          tooltip: {
            message:
              "The colored background behind your event details display.",
            url: "https://help.display.church/en/articles/8532359-design-events-listing-details-details-popup-background-background",
          },
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: true,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Background",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "detailsBackgroundColor",
          defaultValue: "#fdfdfd",
          style: [
            {
              selector: ".event-details--wrapper",
              property: "background-color",
            },
          ],
          tooltip: {
            url: "https://help.display.church/en/articles/5907751-design-events-listing-details-colors-details",
            message: "Event details background color",
          },
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Link",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "anchorColor",
          defaultValue: "#6B6B6B",
          style: [
            {
              selector: [".event-row--details .anchor", ".p a"],
              property: "color",
            },
          ],

          tooltip: {
            url: "https://help.display.church/en/articles/5907751-design-events-listing-details-colors-details",
            message: "Color of URL in description",
          },
          control: {
            kind: "color",
            options: {
              showInherit: true,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Link hover",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          applicable: "design",
          name: "anchorColorHover",
          defaultValue: "#ABABAB",
          style: [
            {
              selector: [".event-row--details .anchor:hover", ".p a:hover"],
              property: "color",
            },
          ],
          tooltip: {
            url: "https://help.display.church/en/articles/5907751-design-events-listing-details-colors-details",
            message: "Color of URL on mouse over",
          },
          control: {
            kind: "color",
            options: {
              showInherit: true,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
      ],
    },
    {
      label: "Event recurrence series",
      options: [
        {
          title: "Recurring series header background",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDateBg",
          defaultValue: "#f8d189",
          style: [
            {
              selector: ["li.dce-recurrence-header"],
              property: "background-color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series  header",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDate",
          defaultValue: "#ffffff",
          style: [
            {
              selector: ["li.dce-recurrence-header"],
              property: "color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series item background",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDateItemBg",
          defaultValue: "#f7f7f7",
          style: [
            {
              selector: ["li.dce-recurrence-event-time"],
              property: "background-color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series item text",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDateItem",
          defaultValue: "#6b6b6b",
          style: [
            {
              selector: [
                "li.dce-recurrence-event-time .dce-recurrence-time",
                "li.dce-recurrence-event-time .dce-recurrence-description",
              ],
              property: "color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series item circle",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDateCircle",
          defaultValue: "#f5ad51",
          style: [
            {
              selector: ["li.dce-recurrence-event-time::before"],
              property: "color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series item left border",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesDateItemLeftBorder",
          defaultValue: "#dfdddd",
          style: [
            {
              selector: ["li.dce-recurrence-event-time"],
              property: "border-left-color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series show more button",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesShowMoreBtn",
          defaultValue: "#237ebd",
          style: [
            {
              selector: [".dce-recurrence--more-btn"],
              property: "background",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series show more button on hover",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesShowMoreBtnHover",
          defaultValue: "#237ebd",
          style: [
            {
              selector: [".dce-recurrence--more-btn:hover"],
              property: "background",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series show more button text",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesShowMoreBtnText",
          defaultValue: "#fff",
          style: [
            {
              selector: [".dce-recurrence--more-btn"],
              property: "color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Recurring series show more button text on hover",
          integrations: [IT.google],
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "recurringSeriesShowMoreBtnTextHover",
          defaultValue: "#fff",
          style: [
            {
              selector: [".dce-recurrence--more-btn:hover"],
              property: "color",
            },
          ],
          show: [
            {
              field: "eventDetailsShowRecurringSeries",
              value: 1,
              defaultValue: 0,
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
      ],
    },

    {
      label: "Accordion",
      options: [
        {
          title: "Collapse details bar",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "eventListCollapseBG",
          defaultValue: "#f7f7f7",
          style: [
            {
              selector: [".event-list--details-close"],
              property: "background-color",
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Collapse details bar hover",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "eventListCollapseHoverBG",
          defaultValue: "#f1f1f1",
          style: [
            {
              selector: [".event-list--details-close:hover"],
              property: "background-color",
            },
            {
              selector: [".event-list--details-close"],
              property: "border-bottom-color",
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Collapse event icon",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "eventListCollapseIcon",
          defaultValue: "#808080",
          style: [
            {
              selector: [".event-list--details-close i"],
              property: "color",
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
      ],
    },
    {
      label: "Event Details call-to-action",
      options: [
        {
          title: "CTA button box",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "cPCTA1stBtn",
          defaultValue: {
            bg: "#00aafb",
            bgHover: "#1ac4ff",
            borderRadius: "8px",
            padding: "8px 24px 8px 24px",
          },
          style: {
            selector: [".event-row--details-row .dce--event-card--cta-btn"],
          },
          show: [
            {
              field: "cPopupShowCta1st",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },
        {
          title: "CTA button label",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.card,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
            CT.detailedList,
            CT.bubble,
          ],
          name: "cPCTA1stBtnTypography",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "500",
            color: "#fff",
            colorHover: "#fff",
          },
          style: {
            selector: [".event-row--details-row .dce--event-card--cta-btn"],
          },
          show: [
            {
              field: "cPopupShowCta1st",
              value: 1,
              defaultValue: 0,
            },
          ],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
      ],
    },
  ],
};
